<template>
  <div>
    <el-collapse v-model="activeNames">
      <el-collapse-item
        v-if="!useScatterClassify"
        title="标记样式"
        name="1"
        @mousedown.native="collapseMouseDown($event, '1')"
      >
        <div
          v-if="
            collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '1') && symbolType !== 'autoImage'
          "
        >
          <span class="top_span">绘制方式</span>
          <el-radio v-model="brushType" label="fill">填充</el-radio>
          <el-radio v-model="brushType" label="stroke">描边</el-radio>
        </div>
        <cx-select class="mt16" title="标记形状" :selectOptions="symbolTypeList" :value.sync="symbolType" />
        <div class="data-item mt16" v-if="symbolType === 'autoImage'">
          <img-upload-simple :imgSrc.sync="symbolImage" />
        </div>
        <slider-and-input
            class="mt16"
            :value.sync="symbolSize"
            titlePosition="singleLine"
            title="标记大小"
            :sliderMax="100"
            suffix="px"
        />

        <div v-if="symbolType !== 'autoImage'">
          <chart-color-setting class="mt16" title="标记颜色" lineDirection="y" :color.sync="lineColor" />
        </div>
      </el-collapse-item>
      <el-collapse-item
        v-if="!useScatterClassify"
        title="涟漪样式"
        name="2"
        @mousedown.native="collapseMouseDown($event, '2')"
      >
        <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '2')">
          <div v-if="symbolType !== 'autoImage'">
            <chart-color-setting class="" title="波纹颜色" :color.sync="roundColor" />
          </div>
          <slider-and-input
            class="mt16"
            :value.sync="scale"
            titlePosition="singleLine"
            title="波纹缩放比"
            :sliderMax="20"
            suffix="%"
          />
          <slider-and-input
              class="mt16"
              :value.sync="period"
              titlePosition="singleLine"
              title="动画时间"
              :sliderMax="20"
              suffix="秒"
          />
          <cx-check-box class="mt16" :value.sync="showEffectOnHover">高亮时显示波纹</cx-check-box>
        </div>
      </el-collapse-item>
      <el-collapse-item
        v-if="!useScatterClassify"
        title="涟漪文字"
        name="3"
        @mousedown.native="collapseMouseDown($event, '3')"
      >
        <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '3')">
          <cx-check-box :value.sync="showScatterText">显示涟漪文字</cx-check-box>
          <div v-show="showScatterText">
            <text-setting-update
              class="mt8"
              :fontColor.sync="labelFontColor"
              :fontFamily.sync="labelFontFamily"
              :fontSize.sync="labelFontSize"
              :fontWeight.sync="labelFontWeight"
            />
            <slider-and-input
              class="mt16"
              :value.sync="labelOffsetX"
              title="横轴偏移"
              :sliderMin="-100"
              :sliderMax="100"
              suffix="px"
            />
            <slider-and-input
              class="mt16"
              :value.sync="labelOffsetY"
              title="纵轴偏移"
              :sliderMin="-100"
              :sliderMax="100"
              suffix="px"
            />
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item
        v-if="useScatterClassify"
        title="数据组"
        name="5"
        @mousedown.native="collapseMouseDown($event, '1')"
      >
        <div v-for="(item, index) in seriesData" :key="index">
          <collapsibleItem
            :key="index"
            :name="'data' + index"
            :type="item.name"
            :is-active="collapse[item.name].isActive"
            @collapsibleItemClick="collapsibleItemClickHandle($event, index)"
          >
            <div slot="heading">{{ item.name }}</div>
            <div slot="body">
              <scatterSeriesSetting
                :options="options"
                :seriesSettingItem="item"
                :ids="ids"
                :index="index"
                ref="seriesSetting"
              ></scatterSeriesSetting>
            </div>
          </collapsibleItem>
        </div>
      </el-collapse-item>
      <el-collapse-item title="提示框" name="4" @mousedown.native="collapseMouseDown($event, '4')">
        <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '4')">
          <tooltipSetting :options="options" />
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import tooltipSetting from "../mapSettings/tooltipSetting"
import scatterSeriesSetting from "./scatterSeriesSetting"
export default {
  components: {
    tooltipSetting,
    scatterSeriesSetting
  },
  data() {
    return {
      activeNames: [],
      collapseActiveNames: ["1"],
      symbolTypeList: [
        { label: "圆形", value: "circle" },
        { label: "矩形", value: "rect" },
        { label: "圆角矩形", value: "roundRect" },
        { label: "三角形", value: "triangle" },
        { label: "菱形", value: "diamond" },
        { label: "气球", value: "pin" },
        { label: "箭头", value: "arrow" },
        { label: "自定义图片", value: "autoImage" }
      ],
      collapse: {}, // 用来存放当前数据组和图例设置里面的展开收起状态
      collapseDataActiveNames: []
    }
  },
  props: {
    options: Object
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    chartOption() {
      return this.options.chartOption
    },
    brushType: {
      get() {
        return this.chartOption.scatter.rippleEffect.brushType
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.scatter.rippleEffect.brushType", false)
      }
    },
    period: {
      get() {
        return this.chartOption.scatter.rippleEffect.period
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.scatter.rippleEffect.period", false)
      }
    },
    symbolSize: {
      get() {
        return this.chartOption.scatter.symbolSize
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.scatter.symbolSize", false)
      }
    },
    scale: {
      get() {
        return this.chartOption.scatter.rippleEffect.scale
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.scatter.rippleEffect.scale", false)
      }
    },
    roundColor: {
      get() {
        return this.chartOption.scatter.rippleEffect.color
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.scatter.rippleEffect.color", false)
      }
    },
    lineColor: {
      get() {
        return this.chartOption.scatter.color
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.scatter.color", false)
      }
    },
    showScatterText: {
      get() {
        return this.chartOption.scatter.label.show
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.scatter.label.show", false)
      }
    },
    labelFontColor: {
      get() {
        return this.chartOption.scatter.label.labelFontColor
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.scatter.label.labelFontColor", false)
      }
    },
    labelFontFamily: {
      get() {
        return this.chartOption.scatter.label.labelFontFamily
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.scatter.label.labelFontFamily", false)
      }
    },
    labelFontSize: {
      get() {
        return this.chartOption.scatter.label.labelFontSize
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.scatter.label.labelFontSize", false)
      }
    },
    labelFontWeight: {
      get() {
        return this.chartOption.scatter.label.labelFontWeight
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.scatter.label.labelFontWeight", false)
      }
    },
    labelOffsetX: {
      get() {
        return this.chartOption.scatter.label.offset[0]
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.scatter.label.offset.0", false)
      }
    },
    labelOffsetY: {
      get() {
        return this.chartOption.scatter.label.offset[1]
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.scatter.label.offset.1", false)
      }
    },
    symbolType: {
      get() {
        return this.chartOption.scatter.symbolType || "circle"
      },
      set(newVal) {
        if (newVal !== "autoImage") {
          this.$changeOptionsEV(
            [newVal, newVal],
            ["chartOption.scatter.symbolType", "chartOption.scatter.symbol"],
            false
          )
        } else {
          this.$changeOptionsEV(
            [newVal, "image://" + this.symbolImage],
            ["chartOption.scatter.symbolType", "chartOption.scatter.symbol"],
            false
          )
        }
      }
    },
    symbolImage: {
      get() {
        return this.chartOption.scatter.symbolImage || ""
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, "image://" + newVal],
          ["chartOption.scatter.symbolImage", "chartOption.scatter.symbol"],
          false
        )
      }
    },
    useScatterClassify() {
      return this.chartOption.scatter.useScatterClassify || false
    },
    seriesData: {
      get() {
        return this.chartOption.scatter.seriesData || []
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.scatter.seriesData", false)
      }
    },
    showEffectOnHover: {
      get() {
        return this.chartOption.scatter.showEffectOnHover || false
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.scatter.showEffectOnHover", false)
        // 解决设置项不生效的问题
        if(!val){
          this.$changeOptionsEV(false, "chartOption.showScatter", false)
          this.$nextTick(()=>{
            this.$changeOptionsEV(true, "chartOption.showScatter", false)
          })
        }
      }
    }
  },
  created() {
    if (this.chartOption.scatter.useScatterClassify) {
      this.options.chartOption.scatter.seriesData?.forEach(item => {
        this.collapse[item.name] = {
          isActive: false,
          shape_isActive: false,
          text_isActive: false
        }
      })
    }
  },
  mounted() {},
  methods: {
    // 抽屉展开收起方法
    collapsibleItemClickHandle($event, index) {
      this.collapse[$event.type].isActive = $event.isActiveCopy
      const _index = this.collapseDataActiveNames.findIndex(it => it === index)
      _index === -1 ? this.collapseDataActiveNames.push(index + "") : ""
    },
    collapseMouseDown($event, val) {
      if ($event.target.classList[0] === "el-collapse-item__header") {
        const _index = this.collapseActiveNames.findIndex(it => it === val)
        _index === -1 ? this.collapseActiveNames.push(val) : ""
      }
    }
  }
}
</script>

<style scoped>
.top_span {
  margin-right: 16px;
}
</style>
